import React from 'react';

import { useProjectContextValue } from '@qality/common-components/src/lib/QAlityPageConfiguration';
import { LoadingButtonWithTooltip } from '@qality/common-components/src/molecules/LoadingButtonWithTooltip';
import {
  FEATURE_FLAG,
  PREMIUM_FEATURE_TOOLTIP_MESSAGE,
} from '@qality/common-config';
import { StorageOfUniqueServices } from '@qality/common-service';

export function ImportButton(): JSX.Element {
  const project = useProjectContextValue();

  const openTestCasesImportPage = () => {
    const url = StorageOfUniqueServices.get(
      'URLService'
    ).getTestCasesImportLink(project?.key);

    StorageOfUniqueServices.get('AP').navigator.go('site', {
      absoluteUrl: url,
    });
  };

  return (
    <LoadingButtonWithTooltip
      loadingButtonProps={{
        onClick: openTestCasesImportPage,
        isDisabled: !FEATURE_FLAG.isPremium,
      }}
      tooltipProps={{
        content: !FEATURE_FLAG.isPremium && PREMIUM_FEATURE_TOOLTIP_MESSAGE,
      }}
    >
      Import
    </LoadingButtonWithTooltip>
  );
}
